const { navigate } = require("gatsby")

const snippetClickHandler = (e, location) => {
    for (const tag of ["a" /*, "button"*/]) {
      const elm = e.target.closest(tag)
      if (
        elm?.dataset &&
        Object.keys(elm.dataset).filter((attr) =>
          attr.startsWith("content-builder")
        )
      ) {
        if (elm.dataset.contentBuilderNavigate) {
          e.preventDefault()
          // const locationSearch = location.search
          let locationSearch = location.search
          let url = elm.dataset.contentBuilderNavigate
          if (url.includes("?")) {
            locationSearch = locationSearch.replace("?", "&")
          }
          url += locationSearch
          
          navigate(elm.dataset.contentBuilderNavigate + location.search)
          break
        }

        if (elm.dataset.contentBuilderNavigateModal) {
          e.preventDefault()
          let locationSearch = location.search
          let url = elm.dataset.contentBuilderNavigateModal
          if (url.includes("?")) {
            locationSearch = locationSearch.replace("?", "&")
          }
          url += locationSearch
          let refStr = `?referrer=` 
          if (url.includes("?")) {
            refStr = refStr.replace("?", "&")
          }
          url += refStr + window.document.referrer

          navigate(url, {
            state: {
              modal: true,
            },
          })
          break
        }
      }
    }

}

module.exports = { snippetClickHandler }
